import { motion } from 'framer-motion';

interface FormInputProps {
  label?: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  className?: string;
  autoComplete?: string;
}

export const FormInput = ({
  label,
  name,
  type,
  value,
  onChange,
  required = false,
  placeholder,
  error,
  className = '',
  autoComplete,
}: FormInputProps) => {
  return (
    <div className={className}>
      {label && (
        <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor={name}>
          {label}
        </label>
      )}
      <motion.div
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.99 }}
      >
        <input
          className={`w-full px-4 py-3 rounded-lg bg-white/50 backdrop-blur-sm border ${
            error ? 'border-red-500' : 'border-gray-300'
          } focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 focus:ring-opacity-50 transition-all duration-200`}
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          autoComplete={autoComplete}
        />
      </motion.div>
      {error && (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-2 text-sm text-red-600"
        >
          {error}
        </motion.p>
      )}
    </div>
  );
};